import type { ExperimentalQueries } from '../__types__/ExperimentalQueries';
import { MediaType } from '../MediaType';

export const experimentalConnectServlet: ExperimentalQueries['experimentalConnectServlet'] = (
	_,
	{ addonKey, moduleKey },
	{ network },
) => {
	if (!addonKey || !moduleKey) {
		return {
			url: '',
		};
	}

	const formData = prepareFormData(addonKey, moduleKey);

	return network
		.cfetch(`/wiki/plugins/servlet/ac/${addonKey}/${moduleKey}`, {
			method: 'POST',
			// @ts-ignore
			body: new URLSearchParams(formData).toString(),
			headers: {
				'Content-Type': MediaType.X_WWW_FORM_URLENCODED,
			},
		})
		.then((response) => response.json())
		.then((responseJson) => {
			return { url: responseJson.url };
		});
};
function prepareFormData(addonKey: string, moduleKey: string) {
	const formData = new FormData();
	formData.append('plugin-key', addonKey);
	formData.append('key', moduleKey);
	formData.append('width', '100%');
	formData.append('height', '100%');
	formData.append('classifier', 'json');
	return formData;
}
